import { BaseService } from '$lib/api/services/utils/BaseService';
import type {
  CheckGithubRepoAccessRequest,
  CheckGithubRepoAccessResponse,
  CreateHackathonProjectBody,
  CreateHackathonProjectResponse,
  CreateProjectCommentBody,
  CreateProjectCommentResponse,
  CreateProjectLikeBody,
  CreateProjectLikeResponse,
  DeleteProjectCommentBody,
  DeleteProjectCommentResponse,
  DeleteProjectLikeBody,
  DeleteProjectLikeResponse,
  DeleteProjectResponse,
  EditHackathonProjectBody,
  EditHackathonProjectResponse,
  EditProjectCommentBody,
  EditProjectCommentResponse,
  LeaveTeamResponse,
  ListProjectsQuery,
  ListProjectsResponse,
  ListProjectCommentsQuery,
  ListProjectCommentsResponse,
  RetrieveProjectQuery,
  RetrieveProjectResponse,
  RetrieveProjectCommentQuery,
  RetrieveProjectCommentResponse,
  RetrieveProjectLikeQuery,
  RetrieveProjectLikeResponse,
  SubmitHackathonProjectBody,
  SubmitHackathonProjectResponse,
  SubmitHackathonWeeklyUpdateRequest,
  SubmitHackathonWeeklyUpdateResponse,
} from '$shared/api';

export class ProjectService extends BaseService {
  create(
    body: CreateHackathonProjectBody,
  ): Promise<CreateHackathonProjectResponse> {
    return this.client.send('/api/project', {
      method: 'POST',
      body,
    });
  }

  submit(
    body: SubmitHackathonProjectBody,
  ): Promise<SubmitHackathonProjectResponse> {
    return this.client.send('/api/project/submit', {
      method: 'POST',
      body,
    });
  }

  update(
    body: EditHackathonProjectBody,
  ): Promise<EditHackathonProjectResponse> {
    return this.client.send('/api/project', {
      method: 'PUT',
      body,
    });
  }

  getProject(query?: RetrieveProjectQuery): Promise<RetrieveProjectResponse> {
    return this.client.send('/api/project', {
      method: 'GET',
      query,
    });
  }

  list(query?: ListProjectsQuery): Promise<ListProjectsResponse> {
    return this.client.send('/api/projects', {
      method: 'GET',
      query,
    });
  }

  deleteProject(): Promise<DeleteProjectResponse> {
    return this.client.send('/api/project', {
      method: 'DELETE',
    });
  }

  checkGithubRepoAccess(
    body: CheckGithubRepoAccessRequest,
  ): Promise<CheckGithubRepoAccessResponse> {
    return this.client.send('/api/project/check-github-repo', {
      method: 'POST',
      body,
    });
  }

  submitWeeklyUpdate(
    body: SubmitHackathonWeeklyUpdateRequest,
  ): Promise<SubmitHackathonWeeklyUpdateResponse> {
    return this.client.send('/api/project/submit-weekly-update', {
      method: 'POST',
      body,
    });
  }

  leaveTeam(): Promise<LeaveTeamResponse> {
    return this.client.send('/api/project/leave-team', {
      method: 'POST',
    });
  }

  createComment(
    body: CreateProjectCommentBody,
  ): Promise<CreateProjectCommentResponse> {
    return this.client.send('/api/project/comment', {
      method: 'POST',
      body,
    });
  }

  deleteComment(
    body: DeleteProjectCommentBody,
  ): Promise<DeleteProjectCommentResponse> {
    return this.client.send('/api/project/comment', {
      method: 'DELETE',
      body,
    });
  }

  editComment(
    body: EditProjectCommentBody,
  ): Promise<EditProjectCommentResponse> {
    return this.client.send('/api/project/comment', {
      method: 'PUT',
      body,
    });
  }

  retrieveComment(
    query: RetrieveProjectCommentQuery,
  ): Promise<RetrieveProjectCommentResponse> {
    return this.client.send('/api/project/comment', {
      method: 'GET',
      query,
    });
  }

  listComments(
    query: ListProjectCommentsQuery,
  ): Promise<ListProjectCommentsResponse> {
    return this.client.send('/api/project/comments', {
      method: 'GET',
      query,
    });
  }

  createProjectLike(
    body: CreateProjectLikeBody,
  ): Promise<CreateProjectLikeResponse> {
    return this.client.send('/api/project/like', {
      method: 'POST',
      body,
    });
  }

  deleteProjectLike(
    body: DeleteProjectLikeBody,
  ): Promise<DeleteProjectLikeResponse> {
    return this.client.send('/api/project/like', {
      method: 'DELETE',
      body,
    });
  }

  retrieveProjectLikes(
    query: RetrieveProjectLikeQuery,
  ): Promise<RetrieveProjectLikeResponse> {
    return this.client.send('/api/project/likes', {
      method: 'GET',
      query,
    });
  }
}
